import React from 'react';
import ScreenWrapper from '../features/Theme/ScreenWrapper';
import TermsOfBusiness from '../features/LegalDocuments/TermsOfBusiness';

type Props = {
    setActiveRightTab?: Function;
};

export default function TermsOfBusinessScreen({ setActiveRightTab }: Props) {
    return (
        <ScreenWrapper>
            <TermsOfBusiness setActiveRightTab={setActiveRightTab} />
        </ScreenWrapper>
    );
}
